import { ObservableMap } from 'mobx';
import { createStore } from 'satcheljs';
import SpamOptionStore, { SpamScenarioStore } from './schema/SpamOptionStore';

export const spamOptionStore: SpamOptionStore = {
    spamStores: new ObservableMap<string, SpamScenarioStore>(),
};

export const getStore = createStore<SpamOptionStore>('sharedSpamStore', spamOptionStore);
export default getStore;
